<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Login Form</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip bottom></v-tooltip>
            </v-toolbar>
            <v-card-text>
              <v-alert v-if="errorShow" type="error">{{ errorMsg }}</v-alert>
              <v-form ref="form" lazy-validation>
                <v-text-field
                  label="Login"
                  :rules="[rules.required]"
                  name="login"
                  v-model="email"
                  outlined
                  dense
                  prepend-icon="mdi-account"
                  @keyup.enter="login"
                ></v-text-field>

                <v-text-field
                  id="password"
                  :rules="[rules.required]"
                  label="Password"
                  name="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  v-model="password"
                  prepend-icon="mdi-lock"
                  outlined
                  dense
                  @keyup.enter="login"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="login" :loading="loadingLogin">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <template v-if="MSGLogout != undefined">
        <v-card>
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :color="color"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
          >
            {{ MSGLogout }}

            <template v-slot:action="{ attrs }">
              <v-btn dark text v-bind="attrs" @click="snackbar = false">
                Close
              </v-btn>
            </template>
          </v-snackbar>
        </v-card>
      </template>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "login",
  props: {
    source: String,
  },
  data() {
    return {
      // validations
      rules: {
        required: (value) => !!value || "Field required.",
      },

      // Public
      showPassword: false,
      loadingLogin : false ,
      errorShow: false,
      errorMsg: "",
      color: "primary",
      mode: "",
      snackbar: true,
      MSGLogout: "",
      timeout: 6000,
      x: null,
      y: "top",

      // Form Data
      email: "",
      password: "",
    };
  },
  created: function () {
    this.MSGLogout = this.$attrs.Msg;
  },
  methods: {
    login() {
      if (this.$refs.form.validate() != false) {
        this.loadingLogin = true
        axios
          .post(this.$store.getters.getAPI + "/admin/login", {
            email: this.email,
            password: this.password,
          })
          .then((response) => {
            if (response.status == 200) {
              localStorage.setItem("token", response.data.data.token);
              localStorage.setItem( "name",  response.data.data.User.firstname + " " + response.data.data.User.lastname );
              this.$store.commit("SetToken", response.data.data);
              this.loadingLogin = false
              this.$router.push({ name: "Home" });
              this.$parent.$parent.$children[0].drawer = true
            }
          })
          .catch((error) => {
            this.loadingLogin = false
            this.$store.dispatch("PushErrorMsg", error.response.data.message);
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
  },
};
</script>